import { useState } from 'react';
import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';

const Backdrop = styled.div`
  position: fixed; inset: 0; background: rgba(13, 25, 41, .36); display:flex; align-items:center; justify-content:center;
`;
const Modal = styled.div`
  width: 720px; max-width: calc(100% - 24px); background:#fff; border-radius:16px; border:1px solid #e5e8f0; box-shadow:0 16px 48px rgba(0,0,0,.08);
  padding: 16px; display:grid; gap:12px;
`;
const Row = styled.div`display:flex; gap:8px; align-items:center;`;
const Input = styled.input`flex:1; padding:10px 12px; border:1px solid #dbe3f6; border-radius:10px; background:#fff; color:#0b1221;`;
const Textarea = styled.textarea`flex:1; padding:10px 12px; border:1px solid #dbe3f6; border-radius:10px; min-height:88px;`;
const Select = styled.select`padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;

export const CreateEventModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [name, setName] = useState('Новое мероприятие');
  const [type, setType] = useState<'Homework'|'Contest'|'Milestone'|'Exam'>('Homework');
  const nowIso = new Date().toISOString().slice(0,16);
  const inTwoHoursIso = new Date(Date.now() + 2*60*60*1000).toISOString().slice(0,16);
  const [start, setStart] = useState(nowIso);
  const [end, setEnd] = useState(inTwoHoursIso);
  const [duration, setDuration] = useState('0.02:00:00');
  const [minPoints, setMinPoints] = useState(0);
  const [description, setDescription] = useState('Описание мероприятия');
  const [createEvent, { isLoading, error }] = eventApi.useCreateEventMutation();

  if (!open) return null;

  const handleCreate = async () => {
    const payload = {
      name,
      groupId: null as any,
      startTime: new Date(start).toISOString(),
      endTime: new Date(end).toISOString(),
      duration,
      type,
      minimumPointsToPass: minPoints,
      description,
      problemCreationRequests: [{ hash: 'demo-hash', points: 100 }],
    };
    await createEvent(payload as any).unwrap();
    onClose();
  };

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e=> e.stopPropagation()}>
        <Row style={{justifyContent:'space-between'}}>
          <div style={{fontWeight:700}}>Создать мероприятие</div>
          <Btn onClick={onClose}>Закрыть</Btn>
        </Row>
        <Input placeholder="Название" value={name} onChange={e=> setName(e.target.value)} />
        <Row>
          <Select value={type} onChange={e=> setType(e.target.value as any)}>
            <option value="Homework">Домашка</option>
            <option value="Contest">Контест</option>
            <option value="Milestone">Мильстоун</option>
            <option value="Exam">Экзамен</option>
          </Select>
          <Input type="datetime-local" value={start} onChange={e=> setStart(e.target.value)} />
          <Input type="datetime-local" value={end} onChange={e=> setEnd(e.target.value)} />
        </Row>
        <Row>
          <Input placeholder="Продолжительность d.hh:mm:ss" value={duration} onChange={e=> setDuration(e.target.value)} />
          <Input placeholder="Мин. балл" type="number" value={minPoints} onChange={e=> setMinPoints(Number(e.target.value))} />
        </Row>
        <Textarea placeholder="Описание" value={description} onChange={e=> setDescription(e.target.value)} />
        <Row style={{justifyContent:'space-between', alignItems:'center'}}>
          {error && <div style={{color:'#e00', fontSize:12}}>Ошибка создания. Проверьте поля формы.</div>}
          <span />
          <Btn onClick={handleCreate} disabled={isLoading}>Создать</Btn>
        </Row>
      </Modal>
    </Backdrop>
  );
};


